/**
 * a logger abstract class
 */
export abstract class Logger {
  constructor() {}

  log(message: any) {}
  info(message: any) {}
  warn(message: any) {}
  debug(message: any) {}
}
